import { computed } from 'vue';
import { useStore } from '~/store';

export default function useSnackbarQueue() {
  const store = useStore();

  const getSnackbars = computed(() => store.getters['snackbars/getSnackbars']);
  const getSnackbarToDisplay = computed(() => store.getters['snackbars/getSnackbarToDisplay']);
  const snackbarCount = computed(() => getSnackbars.value.length);

  /**
   * Add a snackbar
   * @param snackbar
   * @param deleteCurrentOne
   */
  const addSnackbar = (snackbar, deleteCurrentOne = false) => {
    if (deleteCurrentOne && getSnackbarToDisplay?.value?.id) {
      store.commit('snackbars/deleteSnackbar', getSnackbarToDisplay.value.id);
    }

    store.commit('snackbars/addSnackbar', snackbar);
  };

  /**
   * Delete a snackbar based on its id
   * @param snackbarId
   */
  const deleteSnackbar = (snackbarId) => {
    store.commit('snackbars/deleteSnackbar', snackbarId);
  };

  return {
    getSnackbars,
    getSnackbarToDisplay,
    snackbarCount,
    addSnackbar,
    deleteSnackbar,
  };
}
